import { useEffect } from "react"
import { useDetectAdBlock } from "adblock-detect-react"

import useTracking from "hooks/useTracking"

const useAdBlock = () => {
  const adBlockDetected = undefined || useDetectAdBlock()
  const { track } = useTracking()

  useEffect(() => {
    if (typeof adBlockDetected === "boolean") {
      track("Ad Block Status", {
        blocking: adBlockDetected,
        label: adBlockDetected ? "yes" : "no",
        category: "Content Engagement",
      })
    }
  }, [adBlockDetected])

  return adBlockDetected
}

export default useAdBlock
